<template>
    <div class="AdminUsersList">
        <WCard>
            <DataGrid
                ref="dataGrid"
                class="DataGrid"
                v-bind="dataGridConfig"
                :columns="columns || []"
                :rows="rows || []"
                :loading="isFetching"
            />
        </WCard>

        <Modal
            :opened="[modals.CREATE, modals.UPDATE].includes(modal)"
            :title="$t(`users.${ modals.CREATE === modal ? 'newUser' : 'editUser'}`)"
            #body
            @close="handleCleanModal"
        >
            <UserForm
                :value="(node || {}).data"
                :roleDisabled="!permissions.users"
                @onReset="handleCleanModal"
                @onSubmit="handleUserForm"
            />
        </Modal>

        <ModalRequest
            :opened="modal === modals.REMOVE"
            :title="$t('users.modals.remove.text')"
            :cancelText="$t('actions.cancel')"
            :okText="$t('actions.confirm')"
            :loading="isLoading"
            preventDefault
            @close="handleCleanModal"
            @onAccept="removeUser"
        />
    </div>
</template>
<script>
import {
    Api, apiRequest, rethrowError, notifySuccess, notifyError,
} from '@/api'
import { DataGrid, Modal, ModalRequest } from '@/components'
import { userMixin, entityMixin } from '@/mixins'
import { UserForm } from '../components'
import Grid from './grid'

const MODALS = {
    CREATE: 'CREATE',
    REMOVE: 'REMOVE',
    UPDATE: 'UPDATE',
}

export default {
    name: 'AdminUsersList',
    components: {
        DataGrid,
        Modal,
        ModalRequest,
        UserForm,
    },
    mixins: [userMixin, entityMixin],
    metaInfo () {
        return {
            title: this.$t(`admin.navigation.users`),
        }
    },
    entity () {
        return {
            buttons: [{
                iconLeft: 'plus-circle',
                text: this.$t('users.newUser'),
                onClick: () => this.handleRequest(this.modals.CREATE),
            }],
        }
    },
    data () {
        return {
            columns: Grid.columns,
            rows: [],
            isFetching: false,

            modal: undefined,
            modals: MODALS,
            isLoading: false,

            dataGridConfig: {
                ...Grid.config,
                contextMenu: this.contextMenu,
            },
        }
    },
    mounted () {
        this.getUsers()
    },
    methods: {
        contextMenu ({ node, api }) {
            const renderIcon = icon => `<i class="WIcon icon-${icon} ag-icon" />`
            const { data = {} } = node

            return [
                'copy',
                'separator',
                ...([
                    // {
                    //     name: this.$t('entities.actions.viewDetail'),
                    //     action: () => this.$router.push({ name: 'AdminUsersDetail', params: { id: data.id } }),
                    //     icon: renderIcon('edit'),
                    // },
                    {
                        name: this.$t('entities.actions.edit'),
                        action: () => this.handleRequest(MODALS.UPDATE, node),
                        icon: renderIcon('edit'),
                    },
                    {
                        name: this.$t('entities.actions.delete'),
                        action: () => this.handleRequest(MODALS.REMOVE, node),
                        icon: renderIcon('trash'),
                        disabled: !this.permissions.users || data.locked,
                    },
                ]),
                'separator',
                {
                    name: this.$t('entities.actions.export'),
                    action: () => api.exportDataAsCsv({ columnSeparator: '\t' }),
                    icon: renderIcon('download'),
                },
            ]
        },
        handleRequest (modal, node) {
            this.node = node
            if (modal) this.modal = modal
        },
        handleCleanModal () {
            this.node = undefined
            this.modal = undefined
        },
        handleUserForm () {
            const { data } = this.node || {}
            this.getUsers()
            if ((data || {}).id) notifySuccess(this.$t('users.modals.updatedSuccess'))()
            else notifySuccess(this.$t('users.modals.createdSuccess'))()
            this.handleCleanModal()
        },
        async getUsers () {
            this.isFetching = true
            apiRequest(Api().admin.usersList())
                .then(({ data }) => (this.rows = data))
                .catch(rethrowError(notifyError()))
                .finally(() => (this.isFetching = false))
        },
        async removeUser () {
            this.isLoading = true
            const { data } = this.node
            apiRequest(Api().admin.usersDelete({ id: data.id }))
                .then(() => {
                    notifySuccess(this.$t('users.modals.removeSuccess'))()
                    this.getUsers()
                })
                .catch(rethrowError(notifyError()))
                .finally(() => {
                    this.handleCleanModal()
                    this.isLoading = false
                })
        },
    },
}
</script>
<style lang="scss" scoped>
.DataGrid {
	@include admin-screen-height(88px);

    &::v-deep .ag-row:hover {
        cursor: pointer;
    }
}
</style>
